/**
 * AndVWaterfall - 瀑布图组件
 * 基于 Ant Design Charts Waterfall
 */
import React from 'react';
import { Waterfall } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVWaterfallProps } from '../base/types';

const DEFAULT_WATERFALL_DATA = [
  { category: '年度预算基线', value: 500, flowType: 'total' },
  { category: '影像设备采购', value: 180, flowType: 'increase' },
  { category: '检验设备采购', value: 120, flowType: 'increase' },
  { category: '维保支出', value: -85, flowType: 'decrease' },
  { category: '耗材增补', value: 45, flowType: 'increase' },
  { category: '报废冲减', value: -30, flowType: 'decrease' },
  { category: '结余合计', value: 730, isTotal: true, flowType: 'total' },
];

const DEFAULT_WATERFALL_SCALE = {
  color: {
    domain: ['total', 'increase', 'decrease'],
    range: ['#5B8FF9', '#52C41A', '#F4664A'],
  },
};

const WaterfallWithBase = withBaseChart<AndVWaterfallProps>(Waterfall, {
  chartType: 'AndVWaterfall',
  defaultHeight: 300,
  defaultData: DEFAULT_WATERFALL_DATA,
});

export const AndVWaterfall: React.FC<AndVWaterfallProps> = (props) => {
  const {
    xField = 'category',
    yField = 'value',
    colorField = 'flowType',
    linkStyle,
    connector,
    scale,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
    colorField,
    scale: parseJsonProp(scale) ?? DEFAULT_WATERFALL_SCALE,
  };

  const linkStyleConfig = parseJsonProp(linkStyle);
  if (linkStyleConfig !== undefined) chartProps.linkStyle = linkStyleConfig;

  const connectorConfig = parseJsonProp(connector);
  if (connectorConfig !== undefined) chartProps.connector = connectorConfig;

  return <WaterfallWithBase {...chartProps} />;
};

export type { AndVWaterfallProps };
export default AndVWaterfall;
